import { connect } from 'react-redux';
import * as actions from '../../actions';
import { getDomainState } from '../../selectors';
import { Messages } from './messages';

export default connect(getDomainState, actions)(Messages);
